// extracted by mini-css-extract-plugin
export default {"modalCloseButton":"modalCloseButtonwxPcS"};